import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const API_BASE = '/api';

export default function AdminGate() {
    const [status, setStatus] = useState('checking');

    useEffect(() => {
        fetch(`${API_BASE}/check.php`, {
            credentials: 'include'
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.authed && data.user?.username === 'admin') {
                    setStatus('admin');
                } else {
                    setStatus('denied');
                }
            })
            .catch(() => setStatus('denied'));
    }, []);

    if (status === 'checking') {
        return null;
    }

    if (status !== 'admin') {
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
}